<template>
    <b-modal id="main-order-modal" size="xl" :title="modalTitle" no-close-on-esc no-close-on-backdrop>
        <div class="main-order-form">
            <!-- Ana Sipariş Bilgileri Kartı -->
            <b-card no-body class="mb-2">
                <b-card-body class="p-2">
                    <b-row>
                        <b-col md="4">
                            <b-form-group label="Ana Sipariş No" class="mb-1">
                                <b-form-input :value="value.MainOrderNumber" readonly />
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Sipariş Tarihi" class="mb-1 is-required">
                                <v-date-picker
                                    v-model="value.OrderDate"
                                    placeholder="Sipariş Tarihi"
                                    :disabled="hasSubOrders || isReadOnly"
                                    :disabled-date="disableDatesBeforeOneWeekAgo"
                                ></v-date-picker>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Yakıt Tipi" class="mb-1 is-required">
                                <v-select-list
                                    v-model="fuelType"
                                    :options="fuelTypes"
                                    label="VisibleName"
                                    placeholder="Yakıt Tipi Seçin"
                                    :disabled="hasSubOrders || isReadOnly"
                                ></v-select-list>
                            </b-form-group>
                        </b-col>

                        <b-col md="4">
                            <b-form-group label="Tedarikçi" class="mb-1 is-required">
                                <v-select-list
                                    :options="suppliers"
                                    v-model="supplier"
                                    placeholder="Tedarikçi"
                                    label="Name"
                                    :disabled="hasSubOrders || isReadOnly"
                                ></v-select-list>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Ödeme Yöntemi" class="mb-1 is-required">
                                <v-select
                                    v-model="value.PaymentType"
                                    :options="paymentTypes"
                                    :reduce="(x) => x.id"
                                    label="label"
                                    placeholder="Seçiniz"
                                    :disabled="hasSubOrders || isReadOnly"
                                />
                            </b-form-group>
                        </b-col>

                        <b-col md="4" v-if="value.PaymentType === 1">
                            <b-form-group label="Kredi Kartı" class="mb-1 is-required">
                                <v-select
                                    v-model="value.FuelStorageCreditCardInformationId"
                                    :options="creditCards"
                                    :reduce="(x) => x.Id"
                                    label="CreditCardLast4Value"
                                    placeholder="Kart Seçiniz"
                                    :disabled="hasSubOrders || isReadOnly"
                                />
                            </b-form-group>
                        </b-col>

                        <b-col md="4" v-if="value.PaymentType === 1">
                            <b-form-group label="Kart Son Ödeme Tarihi" class="mb-1 is-required">
                                <v-date-picker
                                    v-model="value.FuelStorageCreditCardLastPaymentDate"
                                    disabled
                                    placeholder="Otomatik Hesaplanır"
                                ></v-date-picker>
                            </b-form-group>
                        </b-col>

                        <b-col md="4">
                            <b-form-group label="Birim Fiyat [TL/lt]" class="mb-1">
                                <b-form-input :value="value.UnitPrice ? value.UnitPrice.toFixed(2) : '0.00'" disabled />
                            </b-form-group>
                        </b-col>

                        <!-- Price Hint Box -->
                        <b-col cols="12" class="mb-2">
                            <div class="price-info-box" :class="`price-info-box--${priceInfo.status}`">
                                <div class="price-info-box__header">
                                    <div class="price-info-box__icon" :class="`price-info-box__icon--${priceInfo.status}`">
                                        <feather-icon :icon="priceInfo.icon || 'HelpCircleIcon'" size="20" />
                                    </div>
                                    <div class="price-info-box__title-wrapper">
                                        <div class="price-info-box__title">{{ priceInfo.title }}</div>
                                        <div class="price-info-box__subtitle" v-if="priceInfo.basePrice && priceInfo.step === 5">
                                            Rafineri: {{ priceInfo.basePrice.toFixed(2) }} TL/lt
                                        </div>
                                        <div class="price-info-box__subtitle" v-else-if="priceInfo.subtitle && priceInfo.step === 5">
                                            {{ priceInfo.subtitle }}
                                        </div>
                                    </div>
                                    <div class="price-info-box__dots" v-if="priceInfo.step < 5">
                                        <span
                                            v-for="i in 4"
                                            :key="i"
                                            class="price-info-box__dot"
                                            :class="{
                                                'price-info-box__dot--done': i <= priceInfo.step,
                                                'price-info-box__dot--current': i === priceInfo.step + 1,
                                            }"
                                        ></span>
                                    </div>
                                </div>

                                <div class="price-info-box__body" v-if="priceInfo.missingFields && priceInfo.missingFields.length > 0">
                                    <div class="price-info-box__next-step">
                                        <feather-icon icon="ArrowRightIcon" size="14" class="text-primary" />
                                        <span
                                            >Sonraki adım: <strong>{{ priceInfo.missingFields[0] }}</strong></span
                                        >
                                    </div>
                                </div>

                                <div class="price-info-box__body" v-else-if="priceInfo.step === 5 && priceInfo.currentDeal">
                                    <div class="price-info-box__result" v-if="priceInfo.currentDeal">
                                        <div class="price-info-box__result-row">
                                            <span>Seçili Ödeme:</span>
                                            <strong>{{ priceInfo.currentDeal.label }}</strong>
                                        </div>
                                        <div class="price-info-box__result-row" v-if="priceInfo.currentDeal.rate > 0">
                                            <span>İskonto:</span>
                                            <strong class="text-success">%{{ priceInfo.currentDeal.rate }}</strong>
                                        </div>
                                        <div class="price-info-box__result-row price-info-box__result-row--total">
                                            <span>Birim Fiyat lt/TL:</span>
                                            <div class="price-info-box__price-compare" v-if="priceInfo.currentDeal.rate > 0 && priceInfo.basePrice">
                                                <span class="price-info-box__old-price">{{ priceInfo.basePrice.toFixed(2) }} TL</span>
                                                <strong class="text-success">{{ priceInfo.currentDeal.finalPrice.toFixed(2) }} TL</strong>
                                            </div>
                                            <strong v-else>{{ priceInfo.currentDeal.finalPrice.toFixed(2) }} TL</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6">
                            <b-form-group label="Toplam Miktar [lt]" class="mb-0 is-required">
                                <v-currency-input
                                    :value="value.TotalQuantity"
                                    @update-value="$emit('update:totalQuantity', $event)"
                                    :disabled="hasSubOrders || isReadOnly"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group label="Sevkiyat / Alt Sipariş Sayısı" class="mb-0 is-required">
                                <b-form-input
                                    type="number"
                                    :value="value.ShipmentCount"
                                    @input="$emit('update:shipmentCount', parseInt($event) || null)"
                                    :disabled="hasSubOrders || isReadOnly"
                                    min="1"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mt-2" v-if="!hasSubOrders && !isReadOnly">
                        <b-col class="text-center">
                            <b-button variant="primary" size="sm" @click="createSubOrderTemplates" :disabled="!canCreateTemplates">
                                <feather-icon icon="PlusIcon" size="14" class="mr-50" />
                                Alt Sipariş Şablonlarını Oluştur
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>

            <!-- Alt Siparişler Tablosu -->
            <b-card no-body v-if="subOrders.length > 0">
                <b-card-header class="p-1 d-flex justify-content-between align-items-center">
                    <span class="font-weight-bold">Alt Siparişler</span>
                    <b-badge :variant="quantityMatch ? 'success' : 'danger'" pill>
                        {{ totalSubOrderQuantity.toLocaleString("tr-TR") }} / {{ (value.TotalQuantity || 0).toLocaleString("tr-TR") }} lt
                    </b-badge>
                </b-card-header>

                <!-- Masaüstü: Tablo görünümü -->
                <div class="d-none d-md-block">
                    <b-table-simple small bordered striped responsive class="mb-0 sub-order-table">
                        <b-thead head-variant="light">
                            <b-tr>
                                <b-th class="text-center" style="min-width: 40px; width: 40px">#</b-th>
                                <b-th style="min-width: 140px">Alt Sipariş No</b-th>
                                <b-th style="min-width: 120px">Miktar [lt]</b-th>
                                <b-th style="min-width: 140px">Termin Tarihi</b-th>
                                <b-th class="text-center" style="min-width: 70px">Durum</b-th>
                                <b-th class="text-center" style="min-width: 60px">İşlem</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(sub, index) in subOrders" :key="index">
                                <b-td class="text-center align-middle">{{ index + 1 }}</b-td>
                                <b-td class="align-middle">
                                    <code v-if="sub.OrderNumber" class="text-success">{{ sub.OrderNumber }}</code>
                                    <span v-else v-b-tooltip.hover title="Sipariş numarası kayıt sonrası sistem tarafından atanacaktır">
                                        <code class="text-muted" style="cursor: help">Otomatik atanacak</code>
                                    </span>
                                </b-td>
                                <b-td class="align-middle">
                                    <v-currency-input
                                        :value="sub.OrderQuantity"
                                        @update-value="updateSubOrderField(index, 'OrderQuantity', $event)"
                                        size="sm"
                                    />
                                </b-td>
                                <b-td class="align-middle">
                                    <v-date-picker
                                        :value="sub.OrderDate"
                                        @input="updateSubOrderField(index, 'OrderDate', $event)"
                                        size="sm"
                                        placeholder="Opsiyonel"
                                        :disabled-date="disableDatesBeforeOrderDate"
                                    />
                                </b-td>
                                <b-td class="text-center align-middle">
                                    <b-badge :variant="isSubOrderComplete(sub) ? 'success' : 'secondary'">
                                        {{ isSubOrderComplete(sub) ? "Hazır" : "Bekliyor" }}
                                    </b-badge>
                                </b-td>
                                <b-td class="text-center align-middle">
                                    <b-button size="sm" variant="outline-primary" @click="editSubOrder(index)">
                                        <feather-icon icon="EditIcon" size="14" />
                                    </b-button>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>

                <!-- Mobil: Kart görünümü -->
                <div class="d-md-none">
                    <div v-for="(sub, index) in subOrders" :key="'m' + index" class="sub-order-card">
                        <div class="sub-order-card__header">
                            <span class="sub-order-card__number">#{{ index + 1 }}</span>
                            <code v-if="sub.OrderNumber" class="text-success">{{ sub.OrderNumber }}</code>
                            <code v-else class="text-muted">Otomatik atanacak</code>
                            <b-badge :variant="isSubOrderComplete(sub) ? 'success' : 'secondary'" class="ml-auto">
                                {{ isSubOrderComplete(sub) ? "Hazır" : "Bekliyor" }}
                            </b-badge>
                        </div>
                        <div class="sub-order-card__body">
                            <div class="sub-order-card__field">
                                <label>Miktar [lt]</label>
                                <v-currency-input
                                    :value="sub.OrderQuantity"
                                    @update-value="updateSubOrderField(index, 'OrderQuantity', $event)"
                                    size="sm"
                                />
                            </div>
                            <div class="sub-order-card__field">
                                <label>Termin Tarihi</label>
                                <v-date-picker
                                    :value="sub.OrderDate"
                                    @input="updateSubOrderField(index, 'OrderDate', $event)"
                                    size="sm"
                                    placeholder="Opsiyonel"
                                />
                            </div>
                        </div>
                        <div class="sub-order-card__footer">
                            <b-button size="sm" variant="outline-primary" block @click="editSubOrder(index)">
                                <feather-icon icon="EditIcon" size="14" class="mr-50" />Detay Düzenle
                            </b-button>
                        </div>
                    </div>
                </div>

                <b-card-footer class="py-50 px-75 bg-light">
                    <small class="text-muted">
                        <feather-icon icon="InfoIcon" size="12" class="mr-50" />
                        Her alt sipariş için <strong>Düzenle</strong> butonuyla detayları doldurun. Termin boş bırakılırsa ana sipariş tarihi
                        kullanılır. Miktarların toplamı ana siparişe eşit olmalıdır.
                    </small>
                </b-card-footer>
            </b-card>

            <!-- Validasyon Hataları -->
            <b-alert variant="danger" :show="!!validationError" class="mb-0 p-50 mt-1">
                <feather-icon icon="AlertTriangleIcon" class="mr-50" />
                {{ validationError }}
            </b-alert>
        </div>

        <!-- Footer -->
        <template #modal-footer>
            <b-row class="w-100 m-0">
                <b-col class="text-right p-0">
                    <b-button variant="success" size="sm" @click="saveMainOrder" :disabled="!canSave">
                        <feather-icon icon="SaveIcon" size="14" class="mr-50" />
                        Ayrı Alt Siparişler Olarak Kaydet
                    </b-button>
                </b-col>
            </b-row>
        </template>
    </b-modal>
</template>

<script>
import {
    VBTooltip,
    BModal,
    BCard,
    BCardBody,
    BCardHeader,
    BCardFooter,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BButtonGroup,
    BBadge,
    BAlert,
    BTableSimple,
    BThead,
    BTbody,
    BTfoot,
    BTr,
    BTh,
    BTd,
} from "bootstrap-vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import VCurrencyInput from "@/components/VCurrencyInput.vue";
import VDatePicker from "@/components/VDatePicker.vue";
import FuelStorageApi from "@/api/fuel-storage";
import SystemDataApi from "@/api/system-data";
import FirmOperationsApi from "@/api/firm-operations";

export default {
    name: "FuelStorageMainOrderModalNew",
    components: {
        BModal,
        BCard,
        BBadge,
        BCardBody,
        BCardHeader,
        BCardFooter,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BButton,
        BButtonGroup,
        BAlert,
        BTableSimple,
        BThead,
        BTbody,
        BTr,
        BTh,
        BTd,
        FeatherIcon,
        VCurrencyInput,
        VDatePicker,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        value: {
            type: Object,
            default: () => ({
                MainOrderNumber: "",
                TotalQuantity: null,
                ShipmentCount: null,
                SubOrders: [],
                FuelTypeId: null,
                FuelTypeName: null,
                OrderDate: null,
                SupplierId: null,
                PaymentType: null,
                FuelStorageCreditCardInformationId: null,
                FuelStorageCreditCardLastPaymentDate: null,
                Vade: null,
                UnitPrice: null,
                FuelStorageSupplierAgreementId: null,
                FuelStorageSupplierIskontoId: null,
                FuelStorageSupplierIskontoRate: null,
            }),
        },
        isEdit: {
            type: Boolean,
            default: false,
        },
        isReadOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fuelTypes: [],
            suppliers: [],
            creditCards: [],
            vadeOptions: [],
            paymentTypes: [
                { id: 0, label: "Peşin" },
                { id: 1, label: "Kredi Kartı" },
                { id: 2, label: "Vadeli" },
                { id: 3, label: "DBS" },
            ],
            refineryPrices: [],
            supplierDiscounts: [],
            supplierAgreements: [],
            priceInfo: {
                step: 0,
                status: "idle",
                icon: "HelpCircleIcon",
                title: "Sipariş Bilgilerini Doldurun",
                message: "Fiyat hesaplaması için gerekli alanları seçin.",
                missingFields: [],
                alternatives: [],
                bestDeal: null,
                currentDeal: null,
                basePrice: null,
            },
        };
    },
    mounted() {
        this.getFuelTypes();
        this.getSuppliers();
        this.getCreditCards();
        this.getPricingData();
    },
    computed: {
        modalTitle() {
            if (!this.value) return "Yeni Ana Sipariş Oluştur";
            if (this.isReadOnly) return `Ana Sipariş Detay - ${this.value.MainOrderNumber}`;
            return this.isEdit ? `Ana Sipariş Güncelle - ${this.value.MainOrderNumber}` : "Yeni Ana Sipariş Oluştur";
        },
        subOrders() {
            return this.value?.SubOrders || [];
        },
        hasSubOrders() {
            return this.subOrders.length > 0;
        },
        fuelType: {
            get() {
                return this.fuelTypes.find((f) => f.Id == this.value.FuelTypeId);
            },
            set(v) {
                this.value.FuelTypeId = v?.Id || null;
                this.value.FuelTypeName = v?.VisibleName || null;
            },
        },
        supplier: {
            get() {
                return this.suppliers.find((s) => s.Id == this.value.SupplierId);
            },
            set(v) {
                this.value.SupplierId = v?.Id || null;
            },
        },
        isAdBlue() {
            const selected = this.fuelTypes.find((f) => f.Id == this.value.FuelTypeId);
            return selected?.VisibleName === "ADBLUE";
        },
        canCreateTemplates() {
            return this.value?.TotalQuantity > 0 && this.value?.ShipmentCount > 0 && this.priceInfo.step === 5;
        },
        totalSubOrderQuantity() {
            return this.subOrders.reduce((sum, sub) => sum + (sub.OrderQuantity || 0), 0);
        },
        quantityMatch() {
            return Math.abs(this.totalSubOrderQuantity - (this.value?.TotalQuantity || 0)) < 0.01;
        },
        allSubOrdersComplete() {
            return this.subOrders.every((sub) => this.isSubOrderComplete(sub));
        },
        validationError() {
            if (this.subOrders.length === 0) return null;
            if (!this.quantityMatch) {
                return `Toplam miktar uyuşmuyor! Girilen: ${this.totalSubOrderQuantity.toLocaleString("tr-TR")} lt, Olması gereken: ${(
                    this.value?.TotalQuantity || 0
                ).toLocaleString("tr-TR")} lt`;
            }
            if (!this.allSubOrdersComplete) {
                return "Tüm alt siparişlerin detayları girilmelidir (Miktar, Şube vd.)!";
            }
            return null;
        },
        canSave() {
            return this.hasSubOrders && this.quantityMatch && this.allSubOrdersComplete && this.value?.MainOrderNumber;
        },
    },
    methods: {
        getFuelTypes() {
            SystemDataApi.FuelType(true).then((res) => {
                this.fuelTypes = res.data.Data;
            });
        },
        getSuppliers() {
            FirmOperationsApi.ListByFirmRole("5").then((res) => {
                this.suppliers = res.data.Data;
            });
        },
        getCreditCards() {
            FuelStorageApi.FuelStorageCreditCardInformation.List().then((res) => {
                this.creditCards = res.data.Data;
            });
        },
        getPricingData() {
            Promise.all([
                FuelStorageApi.FuelStorageRefineryPrice.List(),
                FuelStorageApi.FuelStorageSupplierIskonto.List(),
                FuelStorageApi.FuelStorageSupplierAgreement.List(),
            ]).then(([refineryRes, discountRes, agreementRes]) => {
                this.refineryPrices = refineryRes.data.Data || [];
                this.supplierDiscounts = discountRes.data.Data || [];
                this.supplierAgreements = agreementRes.data.Data || [];
            });
        },
        disableDatesBeforeOneWeekAgo(date) {
            const oneWeekAgo = new Date();
            oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
            oneWeekAgo.setHours(0, 0, 0, 0);
            return date < oneWeekAgo;
        },
        // Alt sipariş termin tarihi en erken ana siparişin sipariş tarihi olabilir.
        // (Termin, siparişin verildiği tarihten önce olamaz.)
        disableDatesBeforeOrderDate(date) {
            if (!this.value || !this.value.OrderDate) return false;
            const orderDate = new Date(this.value.OrderDate);
            orderDate.setHours(0, 0, 0, 0);
            return date < orderDate;
        },
        calculateCardMaturity() {
            if (this.value.PaymentType !== 1 || !this.value.FuelStorageCreditCardInformationId || !this.value.OrderDate) {
                return;
            }
            const card = this.creditCards.find((c) => c.Id === this.value.FuelStorageCreditCardInformationId);
            if (!card) return;

            const orderDate = new Date(this.value.OrderDate);
            const year = orderDate.getFullYear();
            const month = orderDate.getMonth();
            let closingDate = new Date(year, month, card.AccountClosingDay);
            let finalPaymentDate =
                orderDate <= closingDate ? new Date(year, month, card.AccountLastPaymentDay) : new Date(year, month + 1, card.AccountLastPaymentDay);

            this.value.FuelStorageCreditCardLastPaymentDate = finalPaymentDate.toISOString();
            const diffDays = Math.ceil(Math.abs(finalPaymentDate - orderDate) / (1000 * 60 * 60 * 24));
            this.value.Vade = diffDays;
        },
        showExistingPriceInfo() {
            if (!this.value.UnitPrice) {
                this.priceInfo = {
                    step: 5,
                    status: "warning",
                    icon: "AlertCircleIcon",
                    title: "Birim Fiyat Bilgisi Yok",
                    message: "",
                    missingFields: [],
                    currentDeal: null,
                    basePrice: null,
                };
                return;
            }
            const hasDiscount = this.value.FuelStorageSupplierIskontoRate > 0;
            this.priceInfo = {
                step: 5,
                status: hasDiscount ? "success" : "warning",
                icon: hasDiscount ? "CheckCircleIcon" : "AlertCircleIcon",
                title: hasDiscount ? "İskonto Uygulandı" : "İskonto Bulunamadı",
                missingFields: [],
                currentDeal: {
                    label: hasDiscount ? `%${this.value.FuelStorageSupplierIskontoRate} İskonto` : "İskonto Yok",
                    rate: this.value.FuelStorageSupplierIskontoRate || 0,
                    finalPrice: this.value.UnitPrice,
                    hasDiscount: hasDiscount,
                },
                basePrice: null,
            };
        },
        calculatePriceAndInfo() {
            if (this.isReadOnly) return;

            const missingFields = [];
            if (!this.value.FuelTypeId) missingFields.push({ field: "FuelTypeId", label: "Yakıt Tipi", icon: "DropletIcon" });
            if (!this.value.OrderDate) missingFields.push({ field: "OrderDate", label: "Sipariş Tarihi", icon: "CalendarIcon" });
            if (!this.value.SupplierId) missingFields.push({ field: "SupplierId", label: "Tedarikçi", icon: "TruckIcon" });
            if (this.value.PaymentType === null || this.value.PaymentType === undefined)
                missingFields.push({ field: "PaymentType", label: "Ödeme Yöntemi", icon: "CreditCardIcon" });

            if (missingFields.length > 0) {
                const completedCount = 4 - missingFields.length;
                this.priceInfo = {
                    step: completedCount,
                    status: "pending",
                    icon: missingFields[0].icon,
                    title: `${missingFields[0].label} Seçin`,
                    missingFields: missingFields.map((f) => f.label),
                    currentDeal: null,
                    basePrice: null,
                };
                return;
            }

            let orderDate =
                typeof this.value.OrderDate === "string" && this.value.OrderDate.includes(".")
                    ? new Date(this.value.OrderDate.split(".")[2], this.value.OrderDate.split(".")[1] - 1, this.value.OrderDate.split(".")[0])
                    : new Date(this.value.OrderDate);
            if (isNaN(orderDate.getTime())) return;

            // Tedarikçi / ödeme yöntemi / yakıt tipi / tarih değiştiğinde fiyat
            // ve referans alanları sıfırdan hesaplanmalı. Aksi halde önceki seçimden
            // gelen UnitPrice / Iskonto / Agreement değerleri kalıcı oluyor
            // (örn. tedarikçi A → fiyat hesaplanır, tedarikçi B'ye geçilince yeni
            // tedarikçinin sözleşmesi/iskontosu yoksa A'nın fiyatı ekranda
            // ve kayıtta kalıyor). Önce stale değerleri temizle, sonra eşleşen
            // anlaşma/iskontoya göre yeniden doldur.
            this.value.UnitPrice = null;
            this.value.FuelStorageSupplierAgreementId = null;
            this.value.FuelStorageSupplierIskontoId = null;
            this.value.FuelStorageSupplierIskontoRate = null;

            if (this.isAdBlue) {
                const agreement = this.supplierAgreements.find(
                    (x) =>
                        x.SupplierId === this.value.SupplierId &&
                        x.IsActive &&
                        new Date(x.StartDate) <= orderDate &&
                        new Date(x.EndDate) >= orderDate,
                );
                if (agreement) {
                    this.value.UnitPrice = agreement.UnitPrice;
                    this.value.FuelStorageSupplierAgreementId = agreement.Id;
                    this.priceInfo = {
                        step: 5,
                        status: "success",
                        icon: "FileTextIcon",
                        title: "Sözleşme Fiyatı Uygulandı",
                        currentDeal: { label: `Sözleşme: ${agreement.AgreementNo}`, finalPrice: agreement.UnitPrice, rate: 0 },
                    };
                } else {
                    // Sözleşme yoksa UnitPrice/AgreementId yukarıda zaten null'a çekildi.
                    this.priceInfo = { step: 5, status: "warning", icon: "AlertCircleIcon", title: "Sözleşme Bulunamadı", currentDeal: null };
                }
                return;
            }

            const validRefineryPrice = this.refineryPrices
                .filter((x) => new Date(x.StartDate) <= orderDate)
                .sort((a, b) => new Date(b.StartDate) - new Date(a.StartDate))[0];
            if (!validRefineryPrice) {
                this.priceInfo = { step: 4, status: "error", icon: "AlertTriangleIcon", title: "Rafineri Fiyatı Bulunamadı", currentDeal: null };
                return;
            }

            const basePrice = validRefineryPrice.PriceWithoutTax;
            const allDiscounts = this.supplierDiscounts.filter(
                (x) =>
                    x.SupplierId === this.value.SupplierId && new Date(x.StartDate) <= orderDate && (!x.EndDate || new Date(x.EndDate) >= orderDate),
            );

            const alternatives = this.paymentTypes.map((pt) => {
                const discount = allDiscounts.find((d) => d.PaymentType === pt.id);
                const rate = discount ? discount.Rate : 0;
                return {
                    paymentType: pt.id,
                    label: pt.label,
                    rate: rate,
                    finalPrice: parseFloat((basePrice - (basePrice * rate) / 100).toFixed(2)),
                    discountId: discount ? discount.Id : null,
                    hasDiscount: rate > 0,
                };
            });

            const currentDeal = alternatives.find((a) => a.paymentType === this.value.PaymentType);
            if (currentDeal) {
                this.value.UnitPrice = currentDeal.finalPrice;
                this.value.FuelStorageSupplierIskontoId = currentDeal.discountId;
                this.value.FuelStorageSupplierIskontoRate = currentDeal.rate;

                this.priceInfo = {
                    step: 5,
                    status: currentDeal.hasDiscount ? "success" : "warning",
                    icon: currentDeal.hasDiscount ? "CheckCircleIcon" : "AlertCircleIcon",
                    title: currentDeal.hasDiscount ? "Fiyat Hesaplandı" : "İskonto Bulunamadı",
                    currentDeal: currentDeal,
                    basePrice: basePrice,
                };
            } else {
                // currentDeal yoksa UnitPrice/Iskonto alanları yukarıda sıfırlandı,
                // sadece bilgi panelini güncelle (önceki sürümde currentDeal undefined olduğunda
                // currentDeal.hasDiscount okuması çökmesine yol açıyordu).
                this.priceInfo = {
                    step: 5,
                    status: "warning",
                    icon: "AlertCircleIcon",
                    title: "Seçilen ödeme yöntemi için iskonto bulunamadı",
                    currentDeal: null,
                    basePrice: basePrice,
                };
            }
        },

        updateSubOrderField(index, field, value) {
            this.$emit("update:subOrderField", { index, field, value });
        },
        createSubOrderTemplates() {
            if (!this.value || !this.canCreateTemplates) return;

            const count = parseInt(this.value.ShipmentCount) || 0;
            const totalQty = parseFloat(this.value.TotalQuantity) || 0;
            if (count <= 0 || totalQty <= 0) return;

            const templates = [];
            const autoFillQuantity = count === 1 ? totalQty : null;

            for (let i = 0; i < count; i++) {
                templates.push({
                    OrderNumber: null,
                    MainOrderNumber: this.value.MainOrderNumber,
                    OrderQuantity: autoFillQuantity,
                    OrderDate: null,
                    FuelTypeId: this.value.FuelTypeId,
                    FuelTypeName: this.value.FuelTypeName,
                    SupplierId: this.value.SupplierId,
                    VehiclePlateId: null,
                    TrailerPlateId: null,
                    FuelOrderBranchId: null,
                    DriverEmployeeId: null,
                    DriverEmployee: null,
                    PaymentType: this.value.PaymentType,
                    UnitPrice: this.value.UnitPrice,
                    TransportAmount: null,
                    Vade: this.value.Vade,
                    FuelStorageCreditCardInformationId: this.value.FuelStorageCreditCardInformationId,
                    FuelStorageCreditCardLastPaymentDate: this.value.FuelStorageCreditCardLastPaymentDate,
                    FuelStorageSupplierAgreementId: this.value.FuelStorageSupplierAgreementId,
                    FuelStorageSupplierIskontoId: this.value.FuelStorageSupplierIskontoId,
                    FuelStorageSupplierIskontoRate: this.value.FuelStorageSupplierIskontoRate,
                    _index: i,
                    _isDirty: false,
                });
            }
            this.$emit("update:subOrders", templates);
        },
        editSubOrder(index) {
            const sub = this.subOrders[index];
            this.$emit("edit-sub-order", {
                index: index,
                subOrder: { ...sub },
                mainOrderNumber: this.value.MainOrderNumber,
                mainOrderDate: this.value.OrderDate,
                isReadOnly: false,
            });
        },
        isSubOrderComplete(sub) {
            return sub.OrderQuantity > 0 && sub.FuelOrderBranchId && (this.isAdBlue || (sub.VehiclePlateId && sub.TrailerPlateId));
        },
        saveMainOrder() {
            if (!this.canSave) return;
            const payload = this.subOrders.map((sub) => {
                const finalDate = sub.OrderDate ? sub.OrderDate : this.value.OrderDate;
                return {
                    ...sub,
                    MainOrderNumber: this.value.MainOrderNumber,
                    OrderDate: finalDate,
                };
            });
            this.$emit("save", payload);
        },
    },
    watch: {
        "value.MainOrderNumber": {
            immediate: true,
            handler() {
                if (this.isReadOnly || this.isEdit) {
                    this.showExistingPriceInfo();
                } else {
                    this.priceInfo = {
                        step: 0,
                        status: "idle",
                        icon: "HelpCircleIcon",
                        title: "Sipariş Bilgilerini Doldurun",
                        message: "Fiyat hesaplaması için gerekli alanları seçin.",
                        missingFields: [],
                        currentDeal: null,
                        basePrice: null,
                    };
                }
            },
        },
        "value.FuelStorageCreditCardInformationId": function () {
            this.calculateCardMaturity();
        },
        "value.OrderDate": function () {
            this.calculateCardMaturity();
            this.calculatePriceAndInfo();
        },
        "value.PaymentType": function (newVal) {
            if (newVal === 1) {
                this.calculateCardMaturity();
            } else {
                this.value.Vade = 0;
            }
            this.calculatePriceAndInfo();
        },
        "value.FuelTypeId": function () {
            this.calculatePriceAndInfo();
        },
        "value.SupplierId": function () {
            this.calculatePriceAndInfo();
        },
    },
};
</script>

<style scoped>
.main-order-form {
    max-height: 80vh;
    overflow-y: auto;
}
.is-required >>> label::after,
.is-required::v-deep label::after {
    content: " *";
    color: #dc3545;
    font-weight: 700;
}
.price-info-box {
    border-radius: 8px;
    padding: 14px 16px;
    border: 1px solid rgba(108, 117, 125, 0.3);
    background: rgba(108, 117, 125, 0.06);
}
.price-info-box--success {
    border-color: rgba(40, 199, 111, 0.4);
    background: rgba(40, 199, 111, 0.08);
}
.price-info-box--warning {
    border-color: rgba(255, 159, 67, 0.4);
    background: rgba(255, 159, 67, 0.08);
}
.price-info-box--error {
    border-color: rgba(234, 84, 85, 0.4);
    background: rgba(234, 84, 85, 0.08);
}
.price-info-box--pending {
    border-color: rgba(13, 110, 253, 0.4);
    background: rgba(13, 110, 253, 0.08);
}
.price-info-box__header {
    display: flex;
    align-items: center;
    gap: 12px;
}
.price-info-box__icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: rgba(108, 117, 125, 0.15);
    color: #6c757d;
}
.price-info-box--pending .price-info-box__icon {
    background: rgba(13, 110, 253, 0.15);
    color: #0d6efd;
}
.price-info-box--success .price-info-box__icon {
    background: rgba(40, 199, 111, 0.15);
    color: #28c76f;
}
.price-info-box--warning .price-info-box__icon {
    background: rgba(255, 159, 67, 0.15);
    color: #ff9f43;
}
.price-info-box--error .price-info-box__icon {
    background: rgba(234, 84, 85, 0.15);
    color: #ea5455;
}
.price-info-box__title-wrapper {
    flex: 1;
    min-width: 0;
}
.price-info-box__title {
    font-weight: 600;
    font-size: 0.95rem;
    color: inherit;
}
.price-info-box__subtitle {
    font-size: 0.8rem;
    opacity: 0.7;
    margin-top: 2px;
}
.price-info-box__dots {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
}
.price-info-box__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: rgba(128, 128, 128, 0.25);
    transition: all 0.2s ease;
}
.price-info-box__dot--done {
    background: #28c76f;
}
.price-info-box__dot--current {
    background: #0d6efd;
    animation: dotPulse 1.5s ease-in-out infinite;
}
@keyframes dotPulse {
    0%,
    100% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.25);
        opacity: 0.7;
    }
}
.price-info-box__body {
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid rgba(128, 128, 128, 0.15);
}
.price-info-box__next-step {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
}
.price-info-box__result {
    background: rgba(128, 128, 128, 0.08);
    border: 1px solid rgba(128, 128, 128, 0.12);
    border-radius: 6px;
    padding: 12px;
}
.price-info-box__result-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
    font-size: 0.9rem;
}
.price-info-box__result-row--total {
    margin-top: 6px;
    padding-top: 10px;
    border-top: 1px solid rgba(128, 128, 128, 0.12);
    font-size: 1rem;
}
.price-info-box__price-compare {
    display: flex;
    align-items: center;
    gap: 8px;
}
.price-info-box__old-price {
    text-decoration: line-through;
    opacity: 0.5;
    font-size: 0.85rem;
}

/* Alt Sipariş Tablo - responsive düzeltmeleri */
.sub-order-table td,
.sub-order-table th {
    white-space: nowrap;
    vertical-align: middle !important;
}

/* Alt Sipariş Mobil Kart */
.sub-order-card {
    border: 1px solid #ebe9f1;
    border-radius: 8px;
    margin-bottom: 0.5rem;
    overflow: hidden;
    background: #fff;
}
.sub-order-card:last-child {
    margin-bottom: 0;
}
.sub-order-card__header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    background: #f8f8f8;
    border-bottom: 1px solid #ebe9f1;
    font-size: 0.85rem;
}
.sub-order-card__number {
    font-weight: 700;
    color: #5e5873;
    min-width: 24px;
}
.sub-order-card__body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
    padding: 0.65rem 0.75rem;
}
.sub-order-card__field label {
    display: block;
    font-size: 0.75rem;
    color: #6e6b7b;
    margin-bottom: 0.2rem;
    font-weight: 600;
}
.sub-order-card__footer {
    padding: 0 0.75rem 0.65rem;
}

@media (max-width: 575.98px) {
    .sub-order-card__body {
        grid-template-columns: 1fr;
    }
}
</style>
